
import OrderTable from './components/order_table.vue'
import OrderStatistics from './components/order_statistics.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import { Component, Vue, Ref } from 'vue-property-decorator'
import { ContactService } from '@/services/index'

@Component({
    components: {
        OrderTable,
        OrderStatistics,
        ScrollTo
    }
})
export default class OrderList extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private activeTab = 'paid'
    private status = 1
    private orderList = []
    private pageIndex = 1
    private pageTotal = 0
    private pageSize = 15

    /* ---------------------- 分界线 ---------------------- */
    private mounted() {
        this.getOrderList()
    }

    private async getOrderList() {
        const params = {
            status: this.status,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await ContactService.getOrderList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.orderList = result.data.list
        }
    }

    private onStatusChange() {
        this.getOrderList()
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getOrderList)
    }

    private onTabChange(tab: any) {
        if (tab.name === 'paid') {
            this.getOrderList()
        }
    }
}
